module.exports = __webpack_public_path__ + "assets/img/32_575_big.c1e9593c.jpg";